import React, { useState, useEffect, useRef } from "react";
import Header from '../Components/Header';
import Hero from '../Components/Hero';
import PixelCarousel from '../Components/PixelCarousel';
import Marquee from '../Components/Marquee';
import Feature from '../Components/Feature';
import Products from '../Components/Products';
import Accordion from '../Components/Accordian';
import Client from '../Components/Client';
import Footer from "../Components/Footer";


const Landing = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const scrollContainerRef = useRef(null);
  
    useEffect(() => {
      const container = scrollContainerRef.current;
  
      const handleScroll = () => {
        if (container.scrollTop > 50) {
          setIsScrolled(true);
        } else {
          setIsScrolled(false);
        }
      };
  
      if (container) {
        container.addEventListener("scroll", handleScroll);
      }
  
      return () => {
        if (container) {
          container.removeEventListener("scroll", handleScroll);
        }
      };
    }, []);
  
    return (
      <div
        className="landing-container"
        ref={scrollContainerRef}
        style={{ overflowY: "auto", height: "100vh" }}
      >
  
  <Header isScrolled={isScrolled} />    
      <Hero />
      <PixelCarousel/>
      <Marquee/>
      <Feature/>
      <Products/>
      <Client />
      <Accordion/>
      <Footer/>
      </div>
      
    
  );
};

export default Landing;
